// src/debug/RouteDebug.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router';

export function RouteDebug() {
  const { pathname, search, hash, state, key } = useLocation();

  useEffect(() => {
    // Logs every navigation
    console.groupCollapsed(`[RR] ${pathname}${search}${hash}  (key: ${key})`);
    console.log('pathname:', pathname);
    console.log('search  :', search);
    console.log('hash    :', hash);
    console.log('state   :', state);
    console.groupEnd();
  }, [pathname, search, hash, state, key]);

  return null;
}
